<div class="w-96 max-w-full">
    <label mat-label [for]="`${actionId()}-name`">Pack name</label>
    <mat-form-field qpxInput class="w-full alt-bg" subscriptSizing="dynamic">
        <input
            matInput
            #nameInput
            [id]="`${actionId()}-name`"
            [formField]="nameField"
            (input)="changed.emit()"
        />
    </mat-form-field>
</div>
@if (description() || descriptionExpanded()) {
    <div>
        <label mat-label [for]="`${actionId()}-description`">Description</label>
        <mat-form-field
            qpxInput
            class="w-full alt-bg"
            subscriptSizing="dynamic"
        >
            <textarea
                #descriptionInput
                matInput
                rows="2"
                [id]="`${actionId()}-description`"
                [formField]="descriptionField"
                (input)="changed.emit()"
            ></textarea>
        </mat-form-field>
    </div>
} @else {
    <button
        qpxButton
        matButton="outlined"
        size="sm"
        class="justify-self-start"
        [disabled]="busy()"
        (click)="addDescription()"
    >
        <ng-icon qpx name="lucidePlus" size="sm" matButtonIcon /><span
            >Add pack description</span
        >
    </button>
}
